import SpinToWin from "./js/SpinToWin.js";

const fetchSpinToWinResults = async (coins, activityId) => {
  try {
    const ajax = Drupal.ajax({
      url: '/api/pepl/activity/' + activityId,
      base: false,
      element: false,
      submit: {
        js: true,
        identifier: 'spin-the-wheel',
      },
      httpMethod: 'POST',
    });

    // ajax.execute() resolves on HTTP response, before the command queue runs.
    // Wrap success() to capture the command queue promise so we can await it,
    // ensuring SettingsCommands (earnedCoins) are applied before we read them.
    const commandQueueDone = new Promise((resolve, reject) => {
      const origSuccess = ajax.success.bind(ajax);
      ajax.success = function (response, status) {
        const result = origSuccess(response, status);
        Promise.resolve(result).then(resolve, reject);
        return result;
      };
    });
    ajax.execute();
    await commandQueueDone;

    // AJAX commands (SettingsCommand) update drupalSettings in-place.
    // Read directly — do not snapshot, as multiple SettingsCommands may
    // replace the UsjoyPepl object reference during execution.

    // Check for error code (set by SettingsCommand on failure).
    const errorCode = drupalSettings.UsjoyPepl?.activityError?.code;
    if (errorCode) {
      delete drupalSettings.UsjoyPepl.activityError;

      if (errorCode.endsWith('_LIMIT_RULE_FAILED')) {
        return { type: 'limit' };
      }
      throw new Error('SpinToWin: Activity error: ' + errorCode);
    }

    const points = drupalSettings.UsjoyPepl?.earnedCoins;

    // Clear stale earned coins to prevent re-reading on next spin.
    if (drupalSettings.UsjoyPepl) {
      delete drupalSettings.UsjoyPepl.earnedCoins;
    }

    if (typeof points !== 'number') {
      console.error('SpinToWin: Missing or invalid points in drupalSettings', drupalSettings.UsjoyPepl);
      throw new Error('SpinToWin: Failed to determine awarded points');
    }

    // Balance updates are handled automatically by Drupal.UsjoyPeplPointsSync
    // via the SettingsCommand for UsjoyPepl.points.

    return { type: 'success', points };
  } catch (error) {
    console.error(error);
    Drupal.toast(Drupal.t("Content not available"), "error");
    throw error;
  }
};

const spinToWin = async (Drupal) => {
  const canvas = document.getElementById("spin-to-win-canvas");
  const sectionEl = document.getElementById("spin-to-win-section");
  const buttonEl = document.querySelector(".spin-to-win__button");
  if (!canvas || !sectionEl || !buttonEl) {
    console.error("Spin to Win canvas, section, or button not found");
    return;
  }

  const isAuthenticated = sectionEl.dataset.isAuthenticated === 'true';
  const loginUrl = sectionEl.dataset.loginUrl;
  const activityId = sectionEl.dataset.activityId;
  const peplSettings = drupalSettings.UsjoyPepl || {};
  const { pointsMessageSingular, pointsMessagePlural } = peplSettings;

  if (!activityId) {
    console.error("Spin to Win: Activity ID not configured");
    return;
  }

  const spinToWinInstance = new SpinToWin({
    canvas,
    sectionEl,
    fetchSpinToWinResults: (coins) => fetchSpinToWinResults(coins, activityId),
    buttonEl,
    showToast: Drupal.toast,
    isAuthenticated,
    loginUrl,
    pointsMessageSingular,
    pointsMessagePlural,
  });
  await spinToWinInstance.init();
};

spinToWin(Drupal);
